export default "__VITE_ASSET__CPxQEB5O__"